import UnauthorizedBase from "../../Base/views/UnauthorizedBase";
import {
  TextField,
  Typography,
  Button,
  Box,
  Card,
  Tooltip,
  IconButton,
  InputAdornment,
  CardContent,
  CardMedia,
  FormControl,
} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from "react";
import SelectableSearch from "../../Base/views/SelectableSearch";
import { addDemoRequestHelper } from "../helper/SignUpHelper";
import RequestSvg from "../../../../svg/RequestSvg";
import Loading from "../image/desk.gif";
import Success from "../../ATS/images/confetti.gif";
import history from "../../../../history";
import { useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getSessionData } from "../../Base/helper/baseHelper";
import { AddExpirePlansHelper } from "../../MeeplAdmin/helper/AddExpirePlansHelper";
import Popup from "../../Base/views/Popup";

const RequestDemo = () => {
  const location = useLocation();
  const region = getSessionData({ key: "region" });
  const defaultPlan = location.state?.defaultPlan || "";
  const defaultteamsize = location.state?.defaultteamsize || "";
  const initialValues = {
    company_name: "",
    country_code: "",
    contactno: "",
    emailid: "",
    teamsize: defaultteamsize,
    plan_type: defaultPlan,
    first_name: "",
    last_name: ""
  };
  const initialValue = { access_grp_org: false, access_face_recg: false };
  const [formData, setFormData] = useState(initialValue);
  const [openPopup, setOpenPopup] = useState(false);
  const [message, setMessage] = useState("Hold tight! We're brewing up your workspace");
  const [imageSrc, setImageSrc] = useState(Loading);
  const options = [
    { value: "Upto 10", label: "Upto 10" },
    { value: "11 to 25", label: "11 to 25" },
    { value: "26 to 50", label: "26 to 50" },
    { value: "51 to 100", label: "51 to 100" },
    { value: "101 to 250", label: "101 to 250" },
    { value: "251 to 500", label: "251 to 500" },
  ];
  const canteenSize = {
      "Upto 10": 10,
      "11 to 25": 25,
      "26 to 50": 50,
      "51 to 100": 100,
      "101 to 250": 250,
      "251 to 500": 500
    };

  const plansoptions = [
    { value: "Starter", label: "Starter" },
    { value: "Growth", label: "Growth" },
    { value: "Premium", label: "Premium" },
  ];

  const [signUpData, setSignUpData] = useState(initialValues);
  const [teamOptions, setTeamOptions] = useState({ load: true, values: [] });
  const [plansOptions, setPlansOptions] = useState({ load: true, values: [] });
  const [errors, setErrors] = useState({});
  const handleChange = (e, value, name) => {
    if (e === "teamsize" || e === "plan_type") {
      if (value) {
        setSignUpData({ ...signUpData, [e]: value });
        if (e === "teamsize") {
          setSignUpData({ ...signUpData, [e]: value });
          const updatedPlansOptions =
            value?.value === "Upto 10" ? plansoptions : plansoptions.slice(1);
          setPlansOptions({ load: false, values: updatedPlansOptions });
        }
      } else setSignUpData({ ...signUpData, [e]: "" });
    } else if (name === "contactno") {
      let phoneNumber = e;
      if (phoneNumber?.startsWith(value?.dialCode)) {
        phoneNumber = phoneNumber?.slice(value?.dialCode?.length);
      }
      setSignUpData({
        ...signUpData,
        country_code: value?.dialCode,
        contactno: phoneNumber || "",
      });
    } else setSignUpData({ ...signUpData, [e.target.name]: e.target.value });
  };
  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("first_name" in fieldValues) {
      temp.first_name =
        fieldValues.first_name?.trim() === "" ? "First Name is required" : "";
    }
    if ("company_name" in fieldValues) {
      temp.company_name =
        fieldValues.company_name?.trim() === ""
          ? "Company Name is required"
          : "";
    }
    if ("teamsize" in fieldValues) {
      temp.teamsize =
        fieldValues.teamsize === "" ? "Team Size is required" : "";
    }
    if ("plan_type" in fieldValues) {
      temp.plan_type =
        fieldValues.plan_type === "" ? "Choose Plan is required" : "";
    }
    if ("contactno" in fieldValues) {
      temp.contactno =
        fieldValues.contactno === "" ? "Contact Number is required" : "";
    }
    if ("emailid" in fieldValues) {
      temp.emailid =
        fieldValues.emailid === ""
          ? "Email is required"
          : /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
            fieldValues.emailid
          )
            ? ""
            : "Invalid Email.";
    }
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    if (validate(signUpData)) {
      setOpenPopup(true);
      addDemoRequestHelper({
        first_name: signUpData?.first_name,
        last_name: signUpData?.last_name,
        emailid: signUpData?.emailid,
        country_code: signUpData?.country_code,
        contactno: signUpData?.contactno,
        company_name: signUpData?.company_name,
        teamsize: signUpData?.teamsize?.value,
        plan_type: signUpData?.plan_type?.value,
      }).then((res) => {
        if (res.message?.statuscode === 200) {
          AddExpirePlansHelper({
            request_demo_id: parseInt(res?.message?.data?.[0]?.request_demo_id),
            planid: parseInt(res?.message?.data?.[0]?.plan_id),
            plan_day: res?.message?.data?.[0]?.expiry_date,
            plan_type: signUpData?.plan_type?.value,
            full_name: `${signUpData?.first_name} ${signUpData?.last_name}`,
            emailid: signUpData?.emailid,
            expiry_days: res?.message?.data?.[0]?.expiry_days,
            access_grp_org: formData?.access_grp_org,
            access_face_recg: formData?.access_face_recg,
            access_payroll: signUpData?.plan_type?.value === "Premium" ? true : false,
            access_ats: signUpData?.plan_type?.value === "Premium" ? true : false,
            visitor_management_flag: true,
            expense_flag: true,
            fnf_flag: false,
            canteen_flag: signUpData?.plan_type?.value === "Premium" ? true : false,
            canteen_team_size: canteenSize[signUpData?.teamsize?.label]

          })
            .then((res) => {
              setMessage("Yeah! Congrats, your workspace is ready. Please check your email to set up your password.");
              setImageSrc(Success);
            })
            .catch((err) => {
              setOpenPopup(false);
              setFormData(initialValue);
              setSignUpData(initialValues);
            });

        }
        if (res.message?.statuscode === 500) {
          setOpenPopup(false);
          setFormData(initialValue);
          setSignUpData(initialValues);
        }
      })
        .catch((err) => {
          setOpenPopup(false);
          setFormData(initialValue);
          setSignUpData(initialValues);
        });
    }
  };

  return (
    <>
      <UnauthorizedBase>
        <Popup
          maxWidth="md"
          fullWidth={true}
          isMasterProduct={true}
          setOpenPopup={setOpenPopup}
          openPopup={openPopup}
          close={false}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#e6f4ea",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              padding: "20px",
              margin: "auto",
            }}
          >
            <img
              src={imageSrc}
              alt="Loading..."
              width={"150px"}
              height={"150px"}
              style={{
                backgroundColor: "#fff",
                borderRadius: "50%",
                padding: "10px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            />
            <Typography sx={{ pt: 1, pb: 1, textAlign: "center" }} variant="h4">
              {message}
            </Typography>
          </Box>
          {message === "Yeah! Congrats, your workspace is ready. Please check your email to set up your password." && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Button
                className="mpl-primary-btn"
                variant="contained"
                onClick={() => {
                  setOpenPopup(false);
                  history.push("/");
                }}
              >
                Ok
              </Button>
            </Box>
          )}
        </Popup>
        <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
          <Card
            sx={{
              boxShadow:
                "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
              p: 1,
              width: "28rem",
            }}
          >
            <CardMedia sx={{ p: 2, textAlign: "center" }}>
              <div style={{ marginBottom: "40px", height: "126px" }}>
                <RequestSvg />
              </div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h3">Signup For Demo</Typography>
              </Box>
            </CardMedia>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <TextField
                  type="text"
                  placeholder="Enter First Name"
                  label="First Name"
                  required
                  name="first_name"
                  onChange={handleChange}
                  value={signUpData.first_name}
                  {...(errors.first_name && {
                    error: true,
                    helperText: errors.first_name,
                  })}
                />

                <TextField
                  sx={{ mt: 2 }}
                  type="text"
                  placeholder="Enter Last Name"
                  label="Last Name"
                  required
                  name="last_name"
                  onChange={handleChange}
                  value={signUpData.last_name}
                  {...(errors.last_name && {
                    error: true,
                    helperText: errors.last_name,
                  })}
                />

                <TextField
                  sx={{ mt: 2, mb: 2 }}
                  type="email"
                  required
                  placeholder="Enter Email ID"
                  label="Email"
                  name="emailid"
                  onChange={handleChange}
                  value={signUpData.emailid}
                  {...(errors.emailid && {
                    error: true,
                    helperText: errors.emailid,
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Please Enter Office Email">
                          <IconButton>
                            <InfoOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>

                    ),
                    maxLength: 4,
                  }}
                />
                <PhoneInput
                  inputProps={{
                    name: "contactno",
                    required: true,
                    autoFocus: true,
                  }}
                  country={region === "au" ? "au" : region === "nz" ? "nz" : "in"}
                  onlyCountries={region === "au" ? ["au"] : region === "nz" ? ["nz"] : []}
                  value={`${signUpData.country_code}${signUpData.contactno}`}
                  onChange={(e, phone) => handleChange(e, phone, "contactno")}
                  inputStyle={{
                    height: "55px",
                    width: "100%",
                    paddingLeft: "45px",
                    borderRightRadius: "8px",
                  }}
                />
                <TextField
                  sx={{ mt: 2 }}
                  type="text"
                  required
                  placeholder="Enter Company Name"
                  label="Company Name"
                  name="company_name"
                  onChange={handleChange}
                  value={signUpData.company_name}
                  {...(errors.company_name && {
                    error: true,
                    helperText: errors.company_name,
                  })}
                />
                <FormControl sx={{ mt: 2 }}>
                  <SelectableSearch
                    label="Team Size"
                    fieldLabel="label"
                    loading={() =>
                      setTeamOptions({ load: false, values: options })
                    }
                    name="teamsize"
                    data={teamOptions}
                    required
                    size="medium"
                    value={signUpData?.teamsize}
                    onChangeEvent={handleChange}
                    {...(errors.teamsize && {
                      error: true,
                      helperText: errors.teamsize,
                    })}
                  />
                </FormControl>
                <FormControl sx={{ mt: 2 }}>
                  <SelectableSearch
                    label="Choose Plan"
                    fieldLabel="label"
                    loading={() =>
                      setPlansOptions({ load: false, values: plansoptions })
                    }
                    name="plan_type"
                    data={plansOptions}
                    required
                    size="medium"
                    value={signUpData?.plan_type}
                    onChangeEvent={handleChange}
                    {...(errors.plan_type && {
                      error: true,
                      helperText: errors.plan_type,
                    })}
                  />
                </FormControl>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Button
                    className="mpl-primary-btn"
                    variant="contained"
                    sx={{ mt: 3, height: "3rem" }}
                    onClick={() => history.push("/")}
                    href="#"
                  >
                    Back
                  </Button>
                  <Button
                    className="mpl-primary-btn"
                    variant="contained"
                    sx={{ mt: 3, height: "3rem" }}
                    onClick={handleSubmit}
                    disabled={Object.values(signUpData)?.includes("")}
                  >
                    Signup
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </UnauthorizedBase>
    </>
  );
};

export default RequestDemo;
